const Socials = () => {
  return (
    <p className="social-medias">
        <a target="_blank" href="#!" rel="noreferrer"><i className="fab fa-facebook"></i></a>
        <a target="_blank" href="#!" rel="noreferrer"><i className="fab fa-instagram"></i></a>
        <a target="_blank" href="#!" rel="noreferrer"><i className="fab fa-youtube"></i></a>
        <a target="_blank" href="#!" rel="noreferrer"><i className="fab fa-linkedin"></i></a>
        <a target="_blank" href="#!" rel="noreferrer"><i className="fab fa-github"></i></a>
    </p>
  )
}

export default Socials
